<template>
  <div class="Login-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1">

          <!-- Loading State -->
          <div v-if="status === 'loading'" class="login-form-wrap">
            <div class="login-header">
              <h3>Verifying your email...</h3>
              <p>Please wait a moment</p>
            </div>
            <div class="login-form">
              <div class="login-body">
                <div class="app-download-section text-center">
                  <div class="app-icon-wrapper mb-4" style="background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)">
                    <i class="ri-loader-4-line app-icon spinning"></i>
                  </div>
                  <h4 class="mb-3">Confirming your account</h4>
                  <p class="text-muted">We're activating your Netwalletpay account...</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Success State -->
          <div v-else-if="status === 'success'" class="login-form-wrap">
            <div class="login-header">
              <h3>Account Activated!</h3>
              <p>Your email has been verified</p>
            </div>
            <div class="login-form">
              <div class="login-body">
                <div class="app-download-section text-center">
                  <div class="app-icon-wrapper mb-4" style="background: linear-gradient(135deg, #10b981 0%, #059669 100%)">
                    <i class="ri-checkbox-circle-line app-icon"></i>
                  </div>
                  <h4 class="mb-3">You're all set!</h4>
                  <p class="mb-4 text-muted">
                    Your Netwalletpay account is now active. Tap the button below to open the app and start your journey.
                  </p>
                  <div class="app-features mb-4">
                    <div class="feature-item">
                      <i class="ri-shield-check-line"></i>
                      <span>Secure Login</span>
                    </div>
                    <div class="feature-item">
                      <i class="ri-exchange-line"></i>
                      <span>Easy Transactions</span>
                    </div>
                    <div class="feature-item">
                      <i class="ri-notification-line"></i>
                      <span>Instant Notifications</span>
                    </div>
                  </div>
                  <a :href="deepLinkSuccess" class="btn style1 download-btn mb-3">
                    <i class="ri-smartphone-line me-2"></i>
                    Open Netwallet App
                  </a>
                  <p class="mt-4 mb-0">
                    Already have an account?
                    <router-link class="link style1" to="/login">Sign In</router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Failure State -->
          <div v-else class="login-form-wrap">
            <div class="login-header">
              <h3>Activation Failed</h3>
              <p>Email verification unsuccessful</p>
            </div>
            <div class="login-form">
              <div class="login-body">
                <div class="app-download-section text-center">
                  <div class="app-icon-wrapper mb-4" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%)">
                    <i class="ri-close-circle-line app-icon"></i>
                  </div>
                  <h4 class="mb-3">Link Expired or Invalid</h4>
                  <p class="mb-4 text-muted">{{ errorMessage }}</p>
                  <a href="https://play.google.com/store/apps/details?id=com.netwalletpay"
                     target="_blank"
                     class="btn style1 download-btn mb-3">
                    <i class="ri-google-play-fill me-2"></i>
                    Download from Google Play
                  </a>
                  <p class="mt-4 mb-0">
                    Already have an account?
                    <router-link class="link style1" to="/login">Sign In</router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

export default {
  name: 'ConfirmEmail',
  setup() {
    const route = useRoute();
    const status = ref('loading'); // 'loading' | 'success' | 'error'
    const errorMessage = ref('The confirmation link is invalid or has expired. Please register again using the Netwallet app.');
    const deepLinkSuccess = 'netwallet://account-verified?success=true&message=Account%20activated!%20Please%20log%20in.';

    onMounted(async () => {
      const { userName, verifyCode } = route.query;

      if (!userName || !verifyCode) {
        status.value = 'error';
        return;
      }

      try {
        await axios.get('/api/v1/account/confirm-email', {
          params: { userName, verifyCode }
        });
        status.value = 'success';
        // Attempt to open the app; if not installed the user sees the button
        window.location.href = deepLinkSuccess;
      } catch (err) {
        status.value = 'error';
        errorMessage.value = err.response?.data?.message || errorMessage.value;
      }
    });

    return { status, errorMessage, deepLinkSuccess };
  }
};
</script>

<style scoped>
.spinning {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
